import React, { FC } from 'react';
import styled from 'styled-components';

import Tooltip from 'crehana-ui/Tooltip';
import { primaryMain } from 'crehana-ui/styles/colors';
import HeartBorderLight from 'crehana-icons/HeartBorderLight';

import { ProductsContext } from 'Jsx/ContextApis/Products';

const StyledHeart = styled.div<{ active: boolean }>`
  ${({ active, theme }) =>
    active &&
    `
    svg path {
      fill: ${theme.colors.primary.main}
    }
  `}
`;

interface WishlistProps {
  course: {
    originalId: number;
    title: string;
    promoImage: string;
    professor: {
      profilePictureUrl: string;
      fullName: string;
    };
    prices: {
      currencySymbol: string;
      price: number;
      realPrice: number;
    };
    url: string;
  };
  isInShoppingCart: boolean;
}

const Wishlist: FC<WishlistProps> = ({
  course: { originalId, title, promoImage, url, professor, prices },
  isInShoppingCart,
}) => {
  const {
    shoppingCartState: { loadingCartMutation },
    wishlistState: { items: wishlistItems },
    toggleWishlistItem,
  } = React.useContext(ProductsContext);

  const wishedCourseActive = wishlistItems
    .map(el => el.originalId)
    .includes(originalId);

  if (!loadingCartMutation && !isInShoppingCart) {
    return (
      <div className="flex items-center mr-20">
        <span className="w-24 pt-4">
          <Tooltip
            label={
              wishedCourseActive
                ? 'Quitar de la lista de deseos'
                : 'Añadir a lista de deseos'
            }
            position="bottom"
            className="tooltip"
          >
            <button type="button">
              <StyledHeart
                className="cursor-pointer"
                active={wishedCourseActive}
                data-cy={`course-wishlist-${
                  wishedCourseActive ? 'remove' : 'add'
                }`}
                onClick={() => {
                  toggleWishlistItem({
                    originalId,
                    title,
                    promoImage,
                    url,
                    professor,
                    prices,
                  });
                }}
              >
                <HeartBorderLight size={20} color={primaryMain} />
              </StyledHeart>
            </button>
          </Tooltip>
        </span>
      </div>
    );
  }

  return null;
};

export default Wishlist;
